import { APIs, API_BASE_URL } from "../constants/Constants";
import axiosInterceptor from "../helpers/Interceptor";

export const getUsersList = async () => {
    try {
        const response = await axiosInterceptor.post(APIs.ADVLICENSEUSERLIST);
        return response;
    } catch (error) {
        if (error.response.status === 403)
            window.location.assign(APIs.REDIRECTLOGOUT);
        else return error.response;
    }
};

export const saveAdvUserList = async (selectedUserIds) => {
    const body = {
        selectedUserIds
    }
    try {
        const response = await axiosInterceptor.post(APIs.ADVLICENSESAVE, {
            data: body,
        });
        return response;
    } catch (error) {
        if (error.response.status === 403)
            window.location.assign(APIs.REDIRECTLOGOUT);
        else return error.response;
    }
};